(function() {
  const product = window.SUNTECH_PRODUCT;
  const def = product.variants.find(v => v.id === product.defaultVariantId) || product.variants[0];
  const selected = def ? def.opts.slice(0, product.optionCount) : [];

  function selectedColor() {
    if (!product.colorPos) return '';
    return (selected[product.colorPos - 1] || '').toLowerCase();
  }

  let galMatching = [];
  let galIndex = 0;

  function showGalImage(idx) {
    if (!galMatching.length) return;
    if (idx < 0) idx = galMatching.length - 1;
    if (idx >= galMatching.length) idx = 0;
    galIndex = idx;
    galMatching.forEach((m, i) => m.classList.toggle('is-active', i === idx));
    const dotsContainer = document.querySelector('[data-suntech-dots]');
    if (dotsContainer) dotsContainer.querySelectorAll('.suntech-product__dot').forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }

  function updateNav() {
    const gal = document.querySelector('[data-suntech-gallery]');
    if (!gal) return;
    const show = galMatching.length > 1;
    const prevBtn = gal.querySelector('[data-suntech-prev]');
    const nextBtn = gal.querySelector('[data-suntech-next]');
    if (prevBtn) prevBtn.style.display = show ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = show ? 'flex' : 'none';
  }

  function playHint() {
    const gal = document.querySelector('[data-suntech-gallery]');
    if (!gal || galMatching.length < 2) return;
    gal.classList.add('is-hint');
    setTimeout(function() { gal.classList.remove('is-hint'); }, 1100);
  }

  function updateVariant() {
    const btn = document.querySelector('.suntech-product__add-cart');
    if (selected.some(function(s) { return !s; })) {
      btn.disabled = true;
      btn.textContent = 'Choisis ta taille';
      return;
    }
    const variant = product.variants.find(function(v) {
      for (let p = 0; p < product.optionCount; p++) {
        if (v.opts[p] !== selected[p]) return false;
      }
      return true;
    });
    if (!variant) return;
    document.querySelector('[data-suntech-variant-id]').value = variant.id;
    document.querySelector('[data-suntech-price]').textContent = (variant.price / 100).toFixed(2).replace('.', ',') + ' €';
    const compareEl = document.querySelector('[data-suntech-compare]');
    if (compareEl) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        compareEl.textContent = (variant.compareAtPrice / 100).toFixed(2).replace('.', ',') + ' €';
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }
    document.querySelector('.suntech-product__add-cart').disabled = !variant.available;
    document.querySelector('.suntech-product__add-cart').textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }

  function renderGallery() {
    const gal = document.querySelector('[data-suntech-gallery]');
    if (!gal) return;
    const imgs = Array.from(gal.querySelectorAll('img'));
    const matching = imgs.filter(img => img.dataset.color === selectedColor());
    const dotsContainer = document.querySelector('[data-suntech-dots]');
    imgs.forEach(img => img.classList.remove('is-shown', 'is-active'));
    if (matching.length === 0) {
      imgs.forEach(img => img.classList.add('is-shown'));
      if (imgs[0]) imgs[0].classList.add('is-active');
      dotsContainer.innerHTML = '';
      galMatching = imgs;
      galIndex = 0;
      updateNav();
      return;
    }
    matching.forEach((img, i) => { img.classList.add('is-shown'); img.classList.toggle('is-active', i === 0); });
    galMatching = matching;
    galIndex = 0;
    dotsContainer.innerHTML = '';
    if (matching.length > 1) {
      matching.forEach((img, idx) => {
        const dot = document.createElement('button');
        dot.className = 'suntech-product__dot' + (idx === 0 ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Photo ' + (idx + 1));
        dot.addEventListener('click', function(ev) {
          ev.preventDefault();
          showGalImage(idx);
        });
        dotsContainer.appendChild(dot);
      });
    }
    updateNav();
  }

  function init() {
    document.querySelectorAll('button.suntech-product__thumb').forEach(btn => {
      const pos = parseInt(btn.dataset.optpos, 10);
      btn.classList.toggle('is-active', btn.dataset.optvalue === selected[pos - 1]);
      btn.addEventListener('click', function() {
        selected[pos - 1] = btn.dataset.optvalue;
        document.querySelectorAll('button.suntech-product__thumb').forEach(b => b.classList.toggle('is-active', b === btn));
        updateVariant();
        renderGallery();
      });
    });
    document.querySelectorAll('.suntech-product__size').forEach(btn => {
      const pos = parseInt(btn.dataset.optpos, 10);
      btn.classList.toggle('is-active', btn.dataset.optvalue === selected[pos - 1]);
      btn.addEventListener('click', function() {
        selected[pos - 1] = btn.dataset.optvalue;
        document.querySelectorAll('.suntech-product__size[data-optpos="' + pos + '"]').forEach(b => b.classList.toggle('is-active', b === btn));
        updateVariant();
      });
    });
    document.querySelectorAll('[data-suntech-opt-select]').forEach(sel => {
      const pos = parseInt(sel.dataset.optpos, 10);
      selected[pos - 1] = sel.value || '';
      sel.addEventListener('change', function() {
        selected[pos - 1] = sel.value;
        updateVariant();
      });
    });
    updateVariant();
    const galEl = document.querySelector('[data-suntech-gallery]');
    if (galEl) {
      let touchStartX = 0, touchStartY = 0, touchTracking = false;
      galEl.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) { touchTracking = false; return; }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchTracking = true;
      }, { passive: true });
      galEl.addEventListener('touchend', function(e) {
        if (!touchTracking) return;
        touchTracking = false;
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          if (dx < 0) showGalImage(galIndex + 1);
          else showGalImage(galIndex - 1);
        }
      }, { passive: true });
      const prevBtn = galEl.querySelector('[data-suntech-prev]');
      const nextBtn = galEl.querySelector('[data-suntech-next]');
      if (prevBtn) prevBtn.addEventListener('click', function(ev) { ev.preventDefault(); showGalImage(galIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function(ev) { ev.preventDefault(); showGalImage(galIndex + 1); });
    }
    renderGallery();
    setTimeout(playHint, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();